// ---------------------------------------------------------------------------
// ozel-alan-goruntuleyici.component.ts
//
// "paylasilmis_kart" / "paylasilmis_kart_sade" bağlamında kullanılan,
// TÜRE GÖRE farklı biçimde gösteren salt-okunur Özel Alan görüntüleyici.
// ozel-alan-duzenleyici.component.ts'in salt-okunur karşılığıdır.
//
// KULLANIM (bir paylasilmis_kart bileşeninde):
//
//   <ozel-alan-goruntuleyici [alanlar]="ozelAlanlar()" />
//
//   ozelAlanlar = computed<IOzelAlan[]>(() => {
//     const v = this.parametreler()?.ek?.ozelAlanlar;
//     return Array.isArray(v) ? v.filter(a => a?.ad) : [];
//   });
// ---------------------------------------------------------------------------
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IOzelAlan, OZEL_ALAN_TIP_BILGI, ozelAlanTipiCoz, ozelAlanGorunenDeger } from './ozel-alan.types';

@Component({
  selector: 'ozel-alan-goruntuleyici',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (alanlar().length) {
      <div class="oag">
        @for (a of alanlar(); track $index) {
          <span class="oag-cip" [class.oag-onay]="tip(a) === 'onay'"
            [class.oag-onay-hayir]="tip(a) === 'onay' && !a.deger"
            [style.--renk]="tip(a) === 'renk' ? a.deger : null">
            @if (tip(a) === 'renk') {
              <span class="oag-renk-nokta" [style.background]="a.deger"></span>
            }
            <b>{{ a.ad }}:</b>
            <span>{{ tip(a) === 'renk' ? a.deger : gorunenDeger(a) }}</span>
          </span>
        }
      </div>
    }
  `,
  styles: [`
    .oag { display:flex; flex-wrap:wrap; gap:4px; }
    .oag-cip { display:inline-flex; align-items:center; gap:3px; padding:2px 8px;
      font-size:11px; font-weight:500; color:var(--py-metin,#444);
      background:rgba(99,102,241,.08); border:1px solid rgba(99,102,241,.25);
      border-radius:999px; line-height:1.4; }
    .oag-cip b { font-weight:700; }
    .oag-onay { background:rgba(34,197,94,.10); border-color:rgba(34,197,94,.3); }
    .oag-onay-hayir { background:rgba(239,68,68,.08); border-color:rgba(239,68,68,.25); }
    .oag-renk-nokta { width:10px; height:10px; border-radius:50%; border:1px solid rgba(0,0,0,.15);
      display:inline-block; background:var(--renk,#ccc); }
  `],
})
export class OzelAlanGoruntuleyiciComponent {
  alanlar = input<IOzelAlan[]>([]);

  readonly OZEL_ALAN_TIP_BILGI = OZEL_ALAN_TIP_BILGI;

  tip(a: IOzelAlan) { return ozelAlanTipiCoz(a); }
  gorunenDeger(a: IOzelAlan) { return ozelAlanGorunenDeger(a); }
}
